export const ecoSystemOptions = [
  {
    label: 'All',
    value: 'all',
    image: ''
  },
  {
    label: 'Bitcoin',
    value: 'bitcoin',
    image: 'bitcoin-ordinals'
  },
  {
    label: 'Ordinals',
    value: 'ordinals',
    image: 'ordinals'
  },
  {
    label: 'Stacks',
    value: 'stacks',
    image: 'stacks'
  },
  {
    label: 'Lightning',
    value: 'lightning',
    image: 'light'
  },
  {
    label: 'Rootstock',
    value: 'rootstock',
    image: 'rootstock'
  },
  {
    label: 'RGB',
    value: 'rgb',
    image: 'rgb'
  },
  {
    label: 'Ark',
    value: 'ark',
    image: 'ark'
  },

  {
    label: 'Nostr',
    value: 'nostr',
    image: 'nostr'
  },
  {
    label: 'Ethereum',
    value: 'ethereum',
    image: 'ethereum'
  },
  {
    label: 'Polygon',
    value: 'polygon',
    image: 'polygon'
  },
  {
    label: 'Arbitrum',
    value: 'arbitrum',
    image: 'arbitrum'
  }, {
    label: 'ZK',
    value: 'zk',
    image: 'zk'
  },
  {
    label: 'Optimism',
    value: 'optimism',
    image: 'op'
  }, {
    label: 'Solana',
    value: 'solana',
    image: 'solana'
  }, {
    label: 'Avalanche',
    value: 'avalanche',
    image: 'ava'
  }, {
    label: 'Climate',
    value: 'Climate',
    image: 'climate'
  }, {
    label: 'AI',
    value: 'AI',
    image: 'ai'
  }, {
    label: 'Web2',
    value: 'Web2',
    image: 'web2'
  }, {
    label: 'Mobile',
    value: 'Mobile',
    image: 'mobile'
  }, {
    label: 'Charity',
    value: 'Charity',
    image: 'charity'
  }, {
    label: 'DAO\'s',
    value: "DAO's",
    image: 'DAO'
  }, {
    label: 'Network States',
    value: 'Network States',
    image: 'network-states'
  }
]

// Bitcoin Ordinals = :bitcoin:
//   Stacks = attached
// Lightning = :zap:
//   Nostr = :bird: - in dark purple if possible
//   Eth = you have
// Polygon attached
// Arbitrum
// ZK (arrows attached)

export const jobCategoryOptions = [
  {
    label: 'Engineering',
    value: 'engineering'
  },
  {
    label: 'Design',
    value: 'design'
  },
  {
    label: 'Management',
    value: 'management'
  },
  {
    label: 'Marketing',
    value: 'marketing'
  },
  {
    label: 'Sales',
    value: 'sales'
  },
  {
    label: 'Support',
    value: 'support'
  }
]

export const jobCategoriesOptions = [
  {
    name: 'Engineering',
    id: 'engineering'
  },
  {
    name: 'Design',
    id: 'design'
  },
  {
    name: 'Management',
    id: 'management'
  },
  {
    name: 'Marketing',
    id: 'marketing'
  },
  {
    name: 'Sales',
    id: 'sales'
  },
  {
    name: 'Support',
    id: 'support'
  }
]

export const jobCategoryOptionsEs = [
  {
    label: 'Ingeniería',
    value: 'engineering'
  },
  {
    label: 'Diseño',
    value: 'design'
  },
  {
    label: 'Gestión',
    value: 'management'
  },
  {
    label: 'Marketing',
    value: 'marketing'
  },
  {
    label: 'Ventas',
    value: 'sales'
  },
  {
    label: 'Soporte',
    value: 'support'
  }
]

export const widgetNavEn = [
  {
    label: 'Search Jobs',
    value: 'search_jobs'
  },
  {
    label: 'Explore Companies',
    value: 'explore_companies'
  },
  {
    label: 'Browse Talent',
    value: 'Browse Talent'
  }
]

export const widgetNavEs = [
  {
    label: 'Buscar ofertas',
    value: 'search_jobs'
  },
  {
    label: 'Explorar empresas',
    value: 'explore_companies'
  },
  {
    label: 'Buscar talento',
    value: 'Browse Talent'
  }
]

export const skeletonCard = [1, 2, 3, 4, 5, 6, 7, 8]

export const skeletonList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]

export const jobTypesJobSeekerForm = [
  {name: 'Permanent', id: 'permanent'},
  {name: 'Contract', id: 'contract'},
  {name: 'Voluntary', id: 'voluntary'},
  {name: 'Freelance', id: 'freelance'},
  {name: 'Bounty', id: 'bounty'},
  {name: 'Co-Founder / Equity Only', id: 'equity'}
]



// WEBPACK FOOTER //
// ./src/constants/array-constants.js